module.exports = __webpack_public_path__ + "static/media/program.04a873b8.png";